module.exports = __webpack_public_path__ + "static/images/containers/BuildingsCarousel/images/bg.7bafe8ef.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingsCarousel/images/bg.png
// module id = 2809
// module chunks = 11